/**
 * Die vier Listenarten eines Projekts aus Sicht des Imports.
 * Entspricht dem Backend-Enum `ProjektListenTyp` (Models_SpsDtos.cs); das
 * Backend überträgt Enums als Klartext.
 */
export type ProjektListenTyp =
  | 'Unbekannt'
  | 'Messstellenliste'
  | 'Verbraucherliste'
  | 'SpsZuordnungsliste'
  | 'PlcTagListe';

/** Nur die beiden SPS-Listen (Backend-Enum `SpsListenTyp`). */
export type SpsListenTyp = 'Zuordnung' | 'PlcTags';

/** Welcher Importweg einen Listentyp speichert. */
export type ImportZiel = 'inbetriebnahme' | 'sps';

/** Beschreibung eines Listentyps für Dialog, Kacheln und Importassistent. */
export interface ListenTypInfo {
  typ: ProjektListenTyp;
  titel: string;
  beschreibung: string;
  importVerfahren: string;
  icon: string;
  /** Messstellen/Verbraucher → bestehender KI-Import; SPS → neuer strukturierter Import. */
  importZiel: ImportZiel;
}

export const LISTEN_TYP_INFOS: ListenTypInfo[] = [
  {
    typ: 'Messstellenliste',
    titel: 'Messstellenliste',
    beschreibung: 'Messstellen und Sensoren',
    importVerfahren: 'KI-gestützter Import',
    icon: 'sensors',
    importZiel: 'inbetriebnahme'
  },
  {
    typ: 'Verbraucherliste',
    titel: 'Verbraucherliste',
    beschreibung: 'Motoren und elektrische Verbraucher',
    importVerfahren: 'KI-gestützter Import',
    icon: 'electrical_services',
    importZiel: 'inbetriebnahme'
  },
  {
    typ: 'SpsZuordnungsliste',
    titel: 'SPS-Zuordnungsliste',
    beschreibung: 'SPS-Module, Kanäle und Anschlüsse',
    importVerfahren: 'Strukturierter Excel-Import ohne KI',
    icon: 'developer_board',
    importZiel: 'sps'
  },
  {
    typ: 'PlcTagListe',
    titel: 'PLC-Tag-Liste',
    beschreibung: 'SPS-Signale, Ein- und Ausgänge',
    importVerfahren: 'Strukturierter Excel-Import ohne KI',
    icon: 'swap_vert',
    importZiel: 'sps'
  }
];

export function listenTypInfo(typ: ProjektListenTyp | string | null | undefined): ListenTypInfo {
  return LISTEN_TYP_INFOS.find(i => i.typ === typ) ?? LISTEN_TYP_INFOS[0];
}

export function istSpsListenTyp(typ: ProjektListenTyp | null | undefined): boolean {
  return typ === 'SpsZuordnungsliste' || typ === 'PlcTagListe';
}

/** Backend-`SpsListenTyp` → Anzeige-Typ. */
export function projektListenTypVonSps(typ: SpsListenTyp): ProjektListenTyp {
  return typ === 'Zuordnung' ? 'SpsZuordnungsliste' : 'PlcTagListe';
}
